// ShopItem.js
import React, { useState, useEffect } from 'react'
import {
    Card,
    CardContent,
    Checkbox,
    Collapse,
    IconButton,
    Typography,
    Box,
    Divider,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    useTheme,
    useMediaQuery
} from '@mui/material'
import { ExpandMore, ExpandLess } from '@mui/icons-material'
import { defaultColors } from '../ColorSchema'

export default function ShopItem(props) {
    const {
        id,
        itemTitle,
        price,
        content,         // array of strings
        options,         // optional: [{ type, cost }, …]
        checked,
        expanded,
        defaultChoice = 0,
        onToggleChecked,
        onToggleExpanded,
        onChoiceChange
    } = props

    const [sel, setSel] = useState(defaultChoice)
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    // inform parent when choice changes
    useEffect(() => {
        if (options && onChoiceChange) {
            onChoiceChange(id, sel)
        }
    }, [sel])

    // header price (desktop) or for mobile–select label
    const headerPrice = options ? options[sel].cost : price

    return (
        <Card
            sx={{
                borderRadius: 3,
                mb: 2,
                boxShadow: 0,
                backgroundColor: defaultColors.surface,
                overflow: 'visible',
                maxWidth: '580px',
                width: '100%'

            }}
        >
            {/* ─── HEADER ─── */}
            <CardContent sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                    <Checkbox
                        aria-label={itemTitle + " CheckBox"}
                        checked={checked}
                        onChange={e => onToggleChecked(id, e.target.checked)}
                    />
                    <Typography variant="h6">{itemTitle}</Typography>
                </Box>

                {/* Desktop-only dropdown */}
                {options && !isMobile && (
                    <FormControl size="small" sx={{ minWidth: 120, mr: 1 }}>
                        <InputLabel>Duration</InputLabel>
                        <Select
                            label="Duration"
                            value={sel}
                            onChange={e => setSel(e.target.value)}
                        >
                            {options.map((o, i) => (
                                <MenuItem key={o.type} value={i}>
                                    {o.type}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}

                {!isMobile && (
                    <Typography variant="h6" sx={{ ml: 2, fontWeight: 500 }}>
                        {headerPrice.toFixed(2).replace('.', ',')}€
                    </Typography>
                )}

                <IconButton aria-label={itemTitle} onClick={() => onToggleExpanded(id)} size="small">
                    {expanded ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
            </CardContent>

            {isMobile && (
                <Box sx={{ px: 2, pb: 1 }}>
                    {options ? (
                        <FormControl fullWidth size="small">
                            <InputLabel>Option</InputLabel>
                            <Select
                                aria-label="Option"
                                label="Option"
                                value={sel}
                                onChange={e => setSel(e.target.value)}
                            >
                                {options.map((o, i) => (
                                    <MenuItem aria-label={o.type + " für " + o.cost} key={o.type} value={i}>
                                        {`${o.type} für ${o.cost
                                            .toFixed(2)
                                            .replace('.', ',')}€`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    ) : (
                        <Typography variant="h6" align="left">
                            {price.toFixed(2).replace('.', ',')}€
                        </Typography>
                    )}
                </Box>
            )}

            {!isMobile && options && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'left',
                        alignItems: 'center',
                        px: 2,
                        pb: 1,
                        pl: '48px'
                    }}
                >
                    {options.map((o, i) => (
                        <React.Fragment key={o.type}>
                            <Box sx={{ textAlign: 'center' }}>
                                <Typography variant="h6">
                                    {o.cost.toFixed(2).replace('.', ',')}€
                                </Typography>
                                <Typography variant="caption" display="block">
                                    {o.type}
                                </Typography>
                            </Box>
                            {i < options.length - 1 && (
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{ mx: 2 }}
                                />
                            )}
                        </React.Fragment>
                    ))}
                </Box>
            )}

            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <Box
                    sx={{
                        backgroundColor: defaultColors.surface,
                        px: 2,
                        py: 1.5,
                        borderRadius: '0 0 16px 16px'
                    }}
                >
                    {content.map((para, i) => (
                        <Typography key={i} variant="body2" paragraph>
                            {para}
                        </Typography>
                    ))}
                </Box>
            </Collapse>
        </Card>
    )
}